import { gql } from 'src/generated/gql';

export const CANCEL_LAB_ORDER = gql(`
  mutation CancelLabOrder($shipmentId: ID!) {
    staff_cancelLabOrder(shipmentId: $shipmentId)
  }
`);
